import { colors } from 'ui/theme/colors';
import { getColor } from '../../utils';
import { SvgIcon, SvgIconProps } from '../../SvgIcon';

export const Calendar16 = ({
  height = 16,
  width = 16,
  color = colors.iconPrimary,
  isColorInherited = false,
  ...props
}: SvgIconProps) => (
  <SvgIcon data-temporary-fix height={height} width={width} viewBox="0 0 16 16" {...props}>
    <path
      d="M7.96698 7.29177C7.58403 7.29177 7.27358 7.60148 7.27358 7.98353V8.04941C7.27358 8.43146 7.58403 8.74118 7.96698 8.74118H8.03302C8.41597 8.74118 8.72642 8.43146 8.72642 8.04941V7.98353C8.72642 7.60148 8.41597 7.29177 8.03302 7.29177H7.96698Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.0802 7.29177C9.69724 7.29177 9.38679 7.60148 9.38679 7.98353V8.04941C9.38679 8.43146 9.69724 8.74118 10.0802 8.74118H10.1462C10.5292 8.74118 10.8396 8.43146 10.8396 8.04941V7.98353C10.8396 7.60148 10.5292 7.29177 10.1462 7.29177H10.0802Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.1934 7.29177C11.8104 7.29177 11.5 7.60148 11.5 7.98353V8.04941C11.5 8.43146 11.8104 8.74118 12.1934 8.74118H12.2594C12.6424 8.74118 12.9528 8.43146 12.9528 8.04941V7.98353C12.9528 7.60148 12.6424 7.29177 12.2594 7.29177H12.1934Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M12.1934 9.4C11.8104 9.4 11.5 9.70971 11.5 10.0918V10.1576C11.5 10.5397 11.8104 10.8494 12.1934 10.8494H12.2594C12.6424 10.8494 12.9528 10.5397 12.9528 10.1576V10.0918C12.9528 9.70971 12.6424 9.4 12.2594 9.4H12.1934Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.0802 9.4C9.69724 9.4 9.38679 9.70971 9.38679 10.0918V10.1576C9.38679 10.5397 9.69724 10.8494 10.0802 10.8494H10.1462C10.5292 10.8494 10.8396 10.5397 10.8396 10.1576V10.0918C10.8396 9.70971 10.5292 9.4 10.1462 9.4H10.0802Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M7.96698 9.4C7.58403 9.4 7.27358 9.70971 7.27358 10.0918V10.1576C7.27358 10.5397 7.58403 10.8494 7.96698 10.8494H8.03302C8.41597 10.8494 8.72642 10.5397 8.72642 10.1576V10.0918C8.72642 9.70971 8.41597 9.4 8.03302 9.4H7.96698Z"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M5.85377 9.4C5.47082 9.4 5.16038 9.70971 5.16038 10.0918V10.1576C5.16038 10.5397 5.47082 10.8494 5.85377 10.8494H5.91981C6.30276 10.8494 6.61321 10.5397 6.61321 10.1576V10.0918C6.61321 9.70971 6.30276 9.4 5.91981 9.4H5.85377Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3.74057 9.4C3.35761 9.4 3.04717 9.70971 3.04717 10.0918V10.1576C3.04717 10.5397 3.35761 10.8494 3.74057 10.8494H3.8066C4.18956 10.8494 4.5 10.5397 4.5 10.1576V10.0918C4.5 9.70971 4.18956 9.4 3.8066 9.4H3.74057Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M3.74057 11.5082C3.35761 11.5082 3.04717 11.8179 3.04717 12.2V12.2659C3.04717 12.6479 3.35761 12.9576 3.74057 12.9576H3.8066C4.18956 12.9576 4.5 12.6479 4.5 12.2659V12.2C4.5 11.8179 4.18956 11.5082 3.8066 11.5082H3.74057Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M5.85377 11.5082C5.47082 11.5082 5.16038 11.8179 5.16038 12.2V12.2659C5.16038 12.6479 5.47082 12.9576 5.85377 12.9576H5.91981C6.30276 12.9576 6.61321 12.6479 6.61321 12.2659V12.2C6.61321 11.8179 6.30276 11.5082 5.91981 11.5082H5.85377Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M7.96698 11.5082C7.58403 11.5082 7.27358 11.8179 7.27358 12.2V12.2659C7.27358 12.6479 7.58403 12.9576 7.96698 12.9576H8.03302C8.41597 12.9576 8.72642 12.6479 8.72642 12.2659V12.2C8.72642 11.8179 8.41597 11.5082 8.03302 11.5082H7.96698Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M10.0802 11.5082C9.69724 11.5082 9.38679 11.8179 9.38679 12.2V12.2659C9.38679 12.6479 9.69724 12.9576 10.0802 12.9576H10.1462C10.5292 12.9576 10.8396 12.6479 10.8396 12.2659V12.2C10.8396 11.8179 10.5292 11.5082 10.1462 11.5082H10.0802Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
    <path
      d="M5.52359 1.69176C5.52359 1.30971 5.21314 1 4.83019 1C4.44724 1 4.13679 1.30971 4.13679 1.69176V2.08706H2.68396C1.75393 2.08706 1 2.83922 1 3.76706V13.32C1 14.2478 1.75394 15 2.68396 15H13.316C14.2461 15 15 14.2478 15 13.32V3.76706C15 2.83922 14.2461 2.08706 13.316 2.08706H11.8632V1.69176C11.8632 1.30971 11.5528 1 11.1698 1C10.7869 1 10.4764 1.30971 10.4764 1.69176V2.08706H5.52359V1.69176ZM5.52359 3.8V3.47059H10.4764V3.8C10.4764 4.18205 10.7869 4.49176 11.1698 4.49176C11.5528 4.49176 11.8632 4.18205 11.8632 3.8V3.47059H13.316C13.4802 3.47059 13.6132 3.60332 13.6132 3.76706V5.24941H2.38679V3.76706C2.38679 3.60332 2.51984 3.47059 2.68396 3.47059H4.13679V3.8C4.13679 4.18205 4.44724 4.49176 4.83019 4.49176C5.21314 4.49176 5.52359 4.18205 5.52359 3.8ZM2.38679 13.32V6.63294H13.6132V13.32C13.6132 13.4837 13.4802 13.6165 13.316 13.6165H2.68396C2.51984 13.6165 2.38679 13.4837 2.38679 13.32Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill={getColor(color, isColorInherited)}
    />
  </SvgIcon>
);
